'use client';

import React from 'react';
import sanitizeHtml from 'sanitize-html';
import BioCard from '../shared/BioCard';
import styles from '../../our-network/styles.module.css';

const sanitizeAndRenderHtml = (
  content: string | undefined
): { __html: string } | undefined => {
  if (!content) return undefined;

  const sanitized = sanitizeHtml(content, {
    allowedAttributes: {
      span: ['class'],
    },
    allowedClasses: {
      span: ['*'], // Allow all classes on span elements
    },
    allowedTags: ['b', 'strong', 'i', 'em', 'u', 'span', 'br', 'p'],
  });

  return { __html: sanitized };
};

interface BoardMember {
  name: string;
  title: string;
  bio: string;
  theme: 'serina' | 'ella';
  cardKey: string;
}

interface BoardSectionProps {
  boardMembers?: BoardMember[];
  sectionHeading?: string;
}

type BoardMemberKey = string | undefined;

const BoardSection = ({
  boardMembers = [],
  sectionHeading = 'Our Board',
}: BoardSectionProps) => {
  const [boardMember, setBoardMember] =
    React.useState<BoardMemberKey>(undefined);

  if (!boardMembers.length) return null;

  return (
    <section className="flex w-full flex-col items-center px-8 py-[48px] md:py-[24px]">
      <div className="content-wrapper mb-4 flex w-full flex-col">
        <h2
          className="pageHeading"
          dangerouslySetInnerHTML={sanitizeAndRenderHtml(sectionHeading)}
        />
      </div>
      <div className="flex w-full max-w-[900px] flex-col">
        <div
          className={`flex md:hidden ${styles.founderCardsContainer} flex-col`}
        >
          {boardMembers.map((member, index) => (
            <BioCard
              key={index}
              name={member.name}
              title={member.title}
              bio={
                <span
                  className="bodyTextDescription"
                  dangerouslySetInnerHTML={sanitizeAndRenderHtml(member.bio)}
                />
              }
              cardKey={member.cardKey}
              currentCard={boardMember}
              onToggle={setBoardMember}
              theme={member.theme}
              solidBackground={true}
              className={styles.founderCard}
            />
          ))}
        </div>

        <div
          className={`hidden md:flex ${styles.founderCardsContainer} align-center justify-center`}
        >
          {boardMembers.map((member, index) => (
            <BioCard
              key={index}
              name={member.name}
              title={member.title}
              bio={
                <span
                  className="bodyTextDescription"
                  dangerouslySetInnerHTML={sanitizeAndRenderHtml(member.bio)}
                />
              }
              cardKey={member.cardKey}
              currentCard={boardMember}
              onToggle={setBoardMember}
              theme={member.theme}
              solidBackground={true}
              className={styles.founderCard}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BoardSection;
